import { FC } from 'react';
import styled from 'styled-components';
import { Tag } from '~/components';
import { useDirection } from '~/hooks/i18nHooks';
import direction from '~/utils/direction';
import colors from '~/constants/colors';
import { KsaAutomatedScreeningResultResolution } from '~/types/ksa/KsaAutomatedScreeningResult';
import { KsaReviewResultStatus } from '~/types/ksa/KsaReviewResult';
import { KsaManualScreeningResultResolution } from '~/types/ksa/KsaManualScreeningResult';

type Result =
  | KsaManualScreeningResultResolution
  | KsaReviewResultStatus
  | KsaAutomatedScreeningResultResolution;

interface Props {
  label: string;
  value: string;
  result: Result;
}

const DecisionField: FC<Props> = (props) => {
  const { label, value, result } = props;
  const dir = useDirection();

  const { backgroundColor, textColor, borderColor } = getStyle(result);
  return (
    <Container dir={dir}>
      <span className="DecisionField-Label">{label}</span>
      <Tag
        color={backgroundColor}
        className="DecisionField-Tag"
        style={{ color: textColor, borderColor }}
      >
        {value}
      </Tag>
    </Container>
  );
};

const Container = styled.div`
  .DecisionField-Label {
    font-weight: 600;
  }
  .DecisionField-Tag {
    display: inline-block;
    font-weight: 600;
    ${direction.margin.left('0.5em')};
  }
`;

const getStyle = (
  decision: Result
): { backgroundColor: string; textColor?: string; borderColor?: string } => {
  switch (decision) {
    case 'FULL_MATCH':
      return { backgroundColor: colors.errorColor };
    case 'PARTIAL_MATCH':
      return { backgroundColor: colors.warningColor };
    case 'MATCH':
      return { backgroundColor: colors.errorColor };
    case 'NO_MATCHES':
      return { backgroundColor: colors.agentStatusGreen };
    case 'ERROR':
      return {
        backgroundColor: colors.errorBackground,
        textColor: colors.errorColor,
        borderColor: colors.errorColor,
      };
    case 'DECLINED':
      return { backgroundColor: colors.errorColor };
    case 'APPROVED':
      return { backgroundColor: colors.agentStatusGreen };
    case 'RESUBMIT':
      return { backgroundColor: colors.warningColor };
    default:
      return { backgroundColor: colors.grey['400'] };
  }
};

export default DecisionField;
